export interface IdentityPaths {
  login: string;
  register: string;
  confirmEmail: string;
  resendConfirmation: string;
}

export interface AppConfig {
  environment: 'development' | 'production' | 'test';
  apiBaseUrl: string;
  identityPaths: IdentityPaths;
}

// Fallbacks if env vars are not provided (useful when .env files are unavailable)
const DEVELOPMENT_API_BASE_URL = 'http://localhost:5220';
const PRODUCTION_API_BASE_URL = 'https://cobudemejist-container.azurewebsites.net';

// Prefer CRA env vars if present; otherwise choose by NODE_ENV
const nodeEnv = (process.env.NODE_ENV as AppConfig['environment']) || 'development';
const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const apiBaseUrl =
  envApiBaseUrl && envApiBaseUrl.trim().length > 0
    ? envApiBaseUrl
    : nodeEnv === 'production'
      ? PRODUCTION_API_BASE_URL
      : DEVELOPMENT_API_BASE_URL;

export const config: AppConfig = {
  environment: nodeEnv,
  apiBaseUrl,
  identityPaths: {
    login: '/api/Account/login',
    register: '/api/Account/register',
    confirmEmail: '/api/Account/confirm-email',
    resendConfirmation: '/api/Account/resend-confirmation'
  }
};

// Debug: Log the configuration in development
if (nodeEnv === 'development') {
  console.log('[Config] Environment:', nodeEnv);
  console.log('[Config] API URL:', apiBaseUrl);
}

export default config;


